const allFeatures = {
  ParkStatus: "Park cards displaying the status of individual device.",
  Announcement: "Announcement feature for the individual facilities",
  NotifiyMe: "form for subscribing to available fields status change.",
  DataDownload: "xls export for graph data",
  FacilityToggle: "toggle the status of the fields/facility",
  Graphs: "detailed graphs",
  WeeklyReport: "weekly reports",
  CustomReport: "custom reports",
  RuleEngine: "rule engine",
};

export const subscriptionType = "starter";

const subscriptionsMap = {
  ParkStatus: { starter: 1, enterprise: 1 },
  FacilityToggle: { starter: 1, enterprise: 1 },
  Graphs: { starter: 1, enterprise: 1 },
  DataDownload: { starter: 0, enterprise: 1 },
  WeeklyReport: { starter: 1, enterprise: 1 },
  Announcement: { starter: 0, enterprise: 1 },
  NotifiyMe: { starter: 0, enterprise: 1 },
};

export function hasFeature({ subscriptionType, feature }) {
  const featureAvailability = subscriptionsMap[feature];
  if (!featureAvailability) {
    throw new Error(`Feature ${feature} does not exist.`);
  }
  return !!featureAvailability[subscriptionType];
}
